import { render } from "./Fab.vue?vue&type=template&id=1c3c2306&scoped=true"
import script from "./Fab.vue?vue&type=script&lang=js"
export * from "./Fab.vue?vue&type=script&lang=js"

import "./Fab.vue?vue&type=style&index=0&id=1c3c2306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3c2306"]])

export default __exports__